import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class XrefDashboardMessageProfileService extends RestfulService<Models.XrefDashboardMessageProfile> {

  constructor(public restService: RestService) {
    super(Models.XrefDashboardMessageProfile);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('xref-dashboard-message-profiles');
  }

}
